import type { EmailStats } from '../../../lib/emailsApi';

interface EmailStatsOverviewProps {
  stats: EmailStats;
}

function StatCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="min-w-0 rounded-lg border border-gray-200 bg-white p-3 sm:p-4">
      <div className="truncate text-[11px] font-medium uppercase tracking-wide text-gray-500 sm:text-xs">
        {label}
      </div>
      <div className="mt-1 text-lg font-bold text-gray-900 sm:text-2xl">{value}</div>
    </div>
  );
}

export function EmailStatsOverview({ stats }: EmailStatsOverviewProps) {
  return (
    <div className="space-y-4">
      {/* Top-line totals */}
      {/* Three short figures: side by side even on a phone. */}
      <div className="grid grid-cols-3 gap-2 sm:gap-4">
        <StatCard label="Total sent" value={stats.totalSent.toLocaleString()} />
        <StatCard label="Total opened" value={stats.totalOpened.toLocaleString()} />
        <StatCard label="Open rate" value={`${stats.openRate.toFixed(1)}%`} />
      </div>

      {/* Per-template breakdown */}
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2 text-left font-medium text-gray-600">Template</th>
              <th className="px-3 py-2 text-right font-medium text-gray-600">Sent</th>
              <th className="px-3 py-2 text-right font-medium text-gray-600">Opened</th>
              <th className="px-3 py-2 text-right font-medium text-gray-600">Open rate</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 bg-white">
            {stats.byTemplate.length === 0 ? (
              <tr>
                <td colSpan={4} className="px-3 py-6 text-center text-gray-500">
                  No emails sent yet.
                </td>
              </tr>
            ) : (
              stats.byTemplate.map((row) => (
                <tr key={row.template}>
                  <td className="px-3 py-2 font-medium text-gray-900">{row.template}</td>
                  <td className="px-3 py-2 text-right text-gray-700">
                    {row.sent.toLocaleString()}
                  </td>
                  <td className="px-3 py-2 text-right text-gray-700">
                    {row.opened.toLocaleString()}
                  </td>
                  <td className="px-3 py-2 text-right font-medium text-gray-900">
                    {row.openRate.toFixed(1)}%
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
